import { useEffect, useRef } from "react";

const useEventListener = (element, eventName, handler) => {
	const savedHandler = useRef();

	useEffect(() => {
		savedHandler.current = handler;
	}, [handler]);

	useEffect(() => {
		if (!element?.addEventListener) return;
		const eventListener = e => savedHandler.current(e);

		if (Array.isArray(eventName)) {
			eventName.forEach(ev => element.addEventListener(ev, eventListener));
		} else {
			element.addEventListener(eventName, eventListener);
		}

		return () => {
			if (Array.isArray(eventName)) {
				eventName.forEach(ev => element.removeEventListener(ev, eventListener));
			} else {
				element.removeEventListener(eventName, eventListener);
			}
		};
	}, [eventName, element]);
};

export default useEventListener;
